var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculated(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V2C18.5 0.9 17.6 0 16.5 0ZM10.53 4.06L11.59 3L13 4.41L14.41 3L15.47 4.06L14.06 5.47L15.47 6.88L14.41 7.94L13 6.54L11.59 7.95L10.53 6.89L11.94 5.48L10.53 4.06ZM3.75 4.72H8.75V6.22H3.75V4.72ZM9 13H7V15H5.5V13H3.5V11.5H5.5V9.5H7V11.5H9V13ZM15.5 14.25H10.5V12.75H15.5V14.25ZM15.5 11.75H10.5V10.25H15.5V11.75Z",
    fill: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V2C18.5 0.9 17.6 0 16.5 0ZM10.53 4.06L11.59 3L13 4.41L14.41 3L15.47 4.06L14.06 5.47L15.47 6.88L14.41 7.94L13 6.54L11.59 7.95L10.53 6.89L11.94 5.48L10.53 4.06ZM3.75 4.72H8.75V6.22H3.75V4.72ZM9 13H7V15H5.5V13H3.5V11.5H5.5V9.5H7V11.5H9V13ZM15.5 14.25H10.5V12.75H15.5V14.25ZM15.5 11.75H10.5V10.25H15.5V11.75Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculated);
export default __webpack_public_path__ + "static/media/Calculated.65785b1372c445679624b74460829de8.svg";
export { ForwardRef as ReactComponent };